var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 26C12 26.55 12.45 27 13 27H17C17.55 27 18 26.55 18 26V25H12V26ZM15 7C11.14 7 8 10.14 8 14C8 16.38 9.19 18.47 11 19.74V22C11 22.55 11.45 23 12 23H18C18.55 23 19 22.55 19 22V19.74C20.81 18.47 22 16.38 22 14C22 10.14 18.86 7 15 7ZM17 18.7V21H13V18.7C11.48 17.63 10 16.53 10 14C10 11.24 12.24 9 15 9C17.76 9 20 11.24 20 14C20 16.49 18.49 17.65 17 18.7Z",
    fill: "#738B6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.5L6 11",
    stroke: "#738B6A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 8L24 10.5",
    stroke: "#738B6A",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0V4.5",
    stroke: "#738B6A",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87939 1.97314L9.12045 6.52787",
    stroke: "#738B6A",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7L23.5 2",
    stroke: "#738B6A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/Tip.5c9c999b5bbe6c48917281392ca0fc1d.svg";
export { ForwardRef as ReactComponent };